<page-header title="Pending Invites"></page-header>
<p class="countInfo">
  You have <span>{{ totalQPInvitations$ | async }}</span> pending connection requests.
</p>

<div class="modal-close">
  <button type="button" mat-dialog-close class="clost-btn">
    <img src="assets/svg/icons/modal-close.svg" />
  </button>
</div>
<div>
  <div class="inviteContainer" *ngFor="let invitation of qpInvitations$ | async">
    <div class="inviteSubContainerAccepted--{{ !!!invitation.qpInviteId }}">
      <div class="invitationHeader qpInvited--{{ !!!invitation.qpInviteId }}">
        <h1>
          <span *ngIf="invitation.qpAdminInviteId && invitation.qpInviteId"><img src="assets/svg/icons/admin-access.svg" /> </span
          >{{ invitation?.companyName }}
        </h1>
        <mat-icon *ngIf="!invitation.qpInviteId">check_circle</mat-icon>
        <p *ngIf="!invitation.qpInviteId">Invite Accepted</p>
      </div>
      <h3 class="qpInvited--{{ !!invitation.qpAdminInviteId }}" *ngIf="invitation.qpInviteId">{{ invitation?.companyType }}</h3>
      <div *ngIf="!invitation.qpInviteId && invitation.qpAdminInviteId" class="acceptAdmin">
        <div>
          <img src="assets/svg/icons/admin-access.svg" />
          <p>Do you also want to accept Admin access?</p>
        </div>
        <div>
          <button class="acceptAdmin" (click)="respondToInvite(invitation, EmailInviteStatus.Accepted, InviteType.Admin_Invite)">
            Yes
          </button>
          <button class="rejectAdmin" (click)="respondToInvite(invitation, EmailInviteStatus.Rejected, InviteType.Admin_Invite)">No</button>
        </div>
      </div>
    </div>
    <div class="actionButtons" *ngIf="invitation.qpInviteId">
      <button class="accept" (click)="respondToInvite(invitation, EmailInviteStatus.Accepted, InviteType.Invite)">
        <mat-icon>check </mat-icon>
      </button>
      <button class="reject" (click)="respondToInvite(invitation, EmailInviteStatus.Rejected, InviteType.Invite)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <p class="footerInfo">* Clients with<img src="assets/svg/icons/admin-access.svg" />are granting full admin access to their portal.</p>
</div>
